import React from 'react';
import { StrategySettingsData } from '../../hooks/useStrategySettings';

interface StrategySettingsFormProps {
    settings: StrategySettingsData;
    onChange: (settings: StrategySettingsData) => void;
    onSave: () => void;
    onCancel: () => void;
    saving: boolean;
}

const StrategySettingsForm: React.FC<StrategySettingsFormProps> = ({
    settings,
    onChange,
    onSave,
    onCancel,
    saving,
}) => {
    return (
        <div className="settings-form">
            <div className="form-group">
                <label htmlFor="targetProfit">목표 수익률 (%)</label>
                <input
                    id="targetProfit"
                    type="number"
                    min="0"
                    max="100"
                    step="0.1"
                    value={settings.targetProfitPercent}
                    onChange={(e) => onChange({
                        ...settings,
                        targetProfitPercent: Number(e.target.value)
                    })}
                />
                <small>예: {settings.targetProfitPercent}% 수익 시 자동 매도</small>
            </div>

            <div className="form-group">
                <label htmlFor="stopLoss">손절 비율 (%)</label>
                <input
                    id="stopLoss"
                    type="number"
                    min="0"
                    max="100"
                    step="0.1"
                    value={settings.stopLossPercent}
                    onChange={(e) => onChange({
                        ...settings,
                        stopLossPercent: Number(e.target.value)
                    })}
                />
                <small>예: -{settings.stopLossPercent}% 손실 시 자동 매도</small>
            </div>

            <hr className="divider" />

            <h3>AI 민감도 설정</h3>

            <div className="form-group">
                <label htmlFor="buyThreshold">매수 민감도 (0.2 ~ 0.8)</label>
                <input
                    id="buyThreshold"
                    type="number"
                    min="0.1"
                    max="1.0"
                    step="0.05"
                    value={settings.buyThreshold}
                    onChange={(e) => onChange({
                        ...settings,
                        buyThreshold: Number(e.target.value)
                    })}
                />
                <small className="threshold-help">
                    <strong>0.8 (보수적):</strong> 확실한 상승장일 때만 매수 (승률 높음, 거래 적음)<br />
                    <strong>0.2 (공격적):</strong> 작은 반등에도 매수 (거래 많음, 속임수 위험)
                </small>
            </div>

            <div className="form-group">
                <label htmlFor="sellThreshold">매도 민감도 (-0.8 ~ -0.2)</label>
                <input
                    id="sellThreshold"
                    type="number"
                    min="-1.0"
                    max="-0.1"
                    step="0.05"
                    value={settings.sellThreshold}
                    onChange={(e) => onChange({
                        ...settings,
                        sellThreshold: Number(e.target.value)
                    })}
                />
                <small className="threshold-help">
                    <strong>-0.8 (느긋함):</strong> 확실한 하락장일 때만 매도 (버티기)<br />
                    <strong>-0.2 (민감함):</strong> 작은 하락에도 즉시 매도 (칼손절)
                </small>
            </div>

            <hr className="divider" />

            <div className="form-group checkbox-group">
                <label>
                    <input
                        type="checkbox"
                        checked={settings.enableTakeProfit}
                        onChange={(e) => onChange({
                            ...settings,
                            enableTakeProfit: e.target.checked
                        })}
                    />
                    <span>자동 수익 실현 활성화</span>
                </label>
                <small>목표 수익률 도달 시 자동으로 포지션을 매도합니다</small>
            </div>

            <div className="form-group checkbox-group">
                <label>
                    <input
                        type="checkbox"
                        checked={settings.enableStopLoss}
                        onChange={(e) => onChange({
                            ...settings,
                            enableStopLoss: e.target.checked
                        })}
                    />
                    <span>자동 손절 활성화</span>
                </label>
                <small>손절 비율 도달 시 자동으로 포지션을 매도합니다</small>
            </div>

            <div className="button-group">
                <button
                    className="save-button"
                    onClick={onSave}
                    disabled={saving}
                >
                    {saving ? '저장 중...' : '저장'}
                </button>
                <button
                    className="cancel-button"
                    onClick={onCancel}
                    disabled={saving}
                >
                    취소
                </button>
            </div>
        </div>
    );
};
export default StrategySettingsForm;
